import React from 'react'

const Tr = ({ children, onClick }) => {
  return (
    <tr onClick={onClick}>
      {children}
    </tr>
  )
}

export default Tr
